document.addEventListener("DOMContentLoaded", function () {
    // Immediately hide the banner (even before Shopify loads)
    let cookieBanner = document.querySelector("#shopify-pc__banner");
    if (cookieBanner) {
        cookieBanner.style.display = "none";
        cookieBanner.style.visibility = "hidden";
    }

    function acceptCookiesShopify() {
        if (window.Shopify && Shopify.customerPrivacy) {
            Shopify.customerPrivacy.setTrackingConsent({
                analytics: true,
                marketing: true,
                preferences: true,
                sale_of_data: true
            });
            console.log("✅ Granular cookies accepted via Shopify API!");
        } else {
            console.log("⏳ Shopify API not ready, retrying...");
            setTimeout(acceptCookiesShopify, 1000); // Retry every 1 second
        }
    }

    // Force Shopify to accept cookies immediately
    acceptCookiesShopify();

    // Keep retrying every 1 second (fixes mobile delay)
    setInterval(acceptCookiesShopify, 1000);
});

